var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSelectionBackground = function SvgIconSelectionBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.75a1 1 0 1 0 0 2H15a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.481 7.625c-.956 0-1.731.775-1.731 1.731V19.52c0 .956.775 1.731 1.731 1.731h10.163c.956 0 1.731-.775 1.731-1.731V9.356c0-.956-.775-1.731-1.731-1.731zM4.75 19.25V9.625h9.625v9.625z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 3.75a1 1 0 0 1 1-1h.75a1.75 1.75 0 0 1 1.75 1.75v.75a1 1 0 1 1-2 0v-.5h-.5a1 1 0 0 1-1-1M21.25 9a1 1 0 1 0-2 0v1.5a1 1 0 1 0 2 0zM20.25 13.25a1 1 0 0 1 1 1V15a1.75 1.75 0 0 1-1.75 1.75h-.75a1 1 0 1 1 0-2h.5v-.5a1 1 0 0 1 1-1M9 2.75A1.75 1.75 0 0 0 7.25 4.5v.75a1 1 0 0 0 2 0v-.5h.5a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconSelectionBackground;